/**
 * @internal
 */
export function parseURLRoute(url, parseEntry) {
    if (typeof url === 'string') {
        url = new URL(url, 'route:/');
    }
    let { pathname } = url;
    if (pathname.length <= 1) {
        return {
            url,
            path: [],
            dir: true,
            section: urlRouteSection,
            toString: urlRouteToString,
            toPathString: urlRoutePathToString,
        };
    }
    let dir = false;
    const from = pathname.length > 1 && pathname.startsWith('/') ? 1 : 0;
    if (pathname.endsWith('/')) {
        dir = true;
        pathname = pathname.substring(from, pathname.length - 1); // Remove leading and trailing slashes
    }
    else {
        pathname = pathname.substr(from); // Remove leading slash
    }
    return {
        url,
        path: pathname.split('/').map(parseEntry),
        dir,
        section: urlRouteSection,
        toString: urlRouteToString,
        toPathString: urlRoutePathToString,
    };
}
/**
 * @internal
 */
export function urlRouteSection(from, to = this.path.length) {
    if (from < 0) {
        from = 0;
    }
    let tillEnd = false;
    if (to < from) {
        to = from;
    }
    if (to >= this.path.length) {
        if (!from) {
            return this;
        }
        to = this.path.length;
        tillEnd = true;
    }
    const path = this.path.slice(from, to);
    const pathname = urlRouteSectionToString(this, from, to);
    let url;
    if (from) {
        url = new URL(pathname, 'route:/');
        if (tillEnd) {
            url = new URL(`?${this.url.searchParams}`, url);
        }
    }
    else {
        url = new URL(`/${pathname}`, this.url);
    }
    return {
        ...this,
        url,
        path,
        dir: this.dir || !tillEnd || !path.length,
    };
}
/**
 * @internal
 */
function urlRouteSectionToString({ path, dir }, fromEntry, toEntry, entryToString = urlRouteEntryToRawString) {
    if (fromEntry >= toEntry) {
        return '';
    }
    let out = '';
    for (let i = fromEntry; i < toEntry; ++i) {
        const entry = path[i];
        if (out) {
            out += '/';
        }
        out += entryToString(entry);
    }
    if ((out && dir) || toEntry < path.length) {
        out += '/';
    }
    return out;
}
/**
 * @internal
 */
function urlRouteToString() {
    return urlRouteSectionToString(this, 0, this.path.length) + this.url.search;
}
/**
 * @internal
 */
function urlRouteEntryToNameString(entry) {
    return entry.rawName;
}
/**
 * @internal
 */
function urlRouteEntryToRawString(entry) {
    return entry.raw;
}
/**
 * @internal
 */
function urlRoutePathToString() {
    return urlRouteSectionToString(this, 0, this.path.length, urlRouteEntryToNameString);
}
//# sourceMappingURL=url-route.impl.js.map